import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { AUDIENCE_INSIGHTS_REPORT_ID } from './audineceInsightsReportId';

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.DATA_PARTNER_AUDIENCE_ID.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.IMPRESSIONS_PCT.field,
        FIELDS.VCTR.field,
        FIELDS.CLICKS.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCPM.field,
        FIELDS.SPENT.field,
        FIELDS.CVR.field,
        FIELDS.CONVERSIONS.field,
        FIELDS.CPA.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CVR_VS_AVG.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(AUDIENCE_INSIGHTS_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [FIELDS.ID.field].map(field => generateColumnId(AUDIENCE_INSIGHTS_REPORT_ID, field)),
};

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.PARTNER_NAME.field,
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.SPENT.field,
    FIELDS.VISIBLE_IMPRESSIONS.field,
    FIELDS.IMPRESSIONS_PCT.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCPM.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS.field,
    FIELDS.CPA.field,
    FIELDS.CVR_VS_AVG.field,
].map(field => generateColumnId(AUDIENCE_INSIGHTS_REPORT_ID, field));

export { customColumns, defaultColumns };
